import { GReCaptcha } from "./g-recaptcha-v3";
import { OtherReCaptchaService } from "./other-recaptcha";
import { RecaptchaHelper } from "./recaptcha-helper";

let module_name = "recaptcha_module";

angular.module(module_name, [])
    .service({
        gReCaptchaService: GReCaptcha,
        otherReCaptchaService: OtherReCaptchaService
    })
    // .factory({
    //     recaptchaFactory: RecaptchaFactory
    // })

export { module_name };

// google recaptcha
// RecaptchaHelper.loadGrecaptchaScriptLabel();